import { Middleware } from "@reduxjs/toolkit";
import { UI_ACTION_NAME, UI_THUNK_ACTION_NAME } from "../reducers/types";
import {
  addActionToHistoryHandler,
  addDataHistoryHandler,
  redoHandler,
  undoHandler,
} from "./handlers/historyHandlers";
import {
  finishedProcessObject,
  initSelectObjectData,
  removeObjectHandler,
  replaceOldToNewSelectObjectData,
  updateValueOption,
} from "./handlers/objectHandlers";
import {
  changeSceneEnvironmentById,
  initFirstEnvironment,
  waitForPlaycanvasReady,
} from "./handlers/environmentHandlers";
import { loadActualDataScene } from "./handlers/sceneHandlers";
import { changeSearchValue } from "./handlers/searchHandlers";

const ACTIONS_WITH_HISTORY = [
  UI_ACTION_NAME.SET_ACTIVE_ENV_VARIANT_VALUE,
  UI_ACTION_NAME.SET_ACTIVE_FOLDER,
  UI_ACTION_NAME.SET_SELECT_OBJECT_DATA,
  UI_ACTION_NAME.INIT_SELECT_OBJECT_DATA,
  UI_ACTION_NAME.REMOVE_SELECT_OBJECT_DATA,
  UI_ACTION_NAME.REPLACE_OBJECT_DATA,
];

export const middleware: Middleware =
  (store: any) => next => async (action: any) => {
    const beforeState = store.getState();

    switch (action.type) {
      case UI_ACTION_NAME.INIT_SELECT_OBJECT_DATA: {
        const { projectId, product } = action.payload;
        initSelectObjectData(projectId, product)(store);
        break;
      }
      case UI_ACTION_NAME.UPDATE_VALUE_OPTION_SELECT_OBJECT: {
        const { productId, type, data } = action.payload;
        updateValueOption(productId, type, data)(store);
        break;
      }
      case UI_ACTION_NAME.REMOVE_OBJECT: {
        const { productId } = action.payload;
        removeObjectHandler(productId)(store);
        break;
      }
      case UI_ACTION_NAME.REPLACE_OBJECT_DATA: {
        const { prevProductId, product, projectId } = action.payload;
        replaceOldToNewSelectObjectData(
          projectId,
          product,
          prevProductId
        )(store);
        break;
      }
      case UI_ACTION_NAME.SET_SEARCH_VALUE: {
        const value = action.payload;
        changeSearchValue(value)(store);
        break;
      }
      case UI_ACTION_NAME.SET_ACTIVE_FOLDER: {
        changeSearchValue("")(store);
        break;
      }
      default: {
        break;
      }
    }

    const result = next(action);
    const afterState = store.getState();

    if (ACTIONS_WITH_HISTORY.includes(action.type)) {
      addActionToHistoryHandler(beforeState, afterState)(store);
    }

    switch (action.type) {
      case UI_ACTION_NAME.UNDO: {
        undoHandler(store);
        break;
      }
      case UI_ACTION_NAME.REDO: {
        redoHandler(store);
        break;
      }
      case UI_ACTION_NAME.ADD_HISTORY: {
        const { before, after } = action.payload;
        addDataHistoryHandler(before, after)(store);
        break;
      }
      case UI_ACTION_NAME.SET_DATA_UI: {
        const { selectObjects } = action.payload;
        loadActualDataScene({
          selectData: selectObjects,
        })(store);
        break;
      }
      case UI_ACTION_NAME.SET_ACTIVE_ENV_INDEX: {
        const id = action.payload;

        changeSceneEnvironmentById(id)(store);
        break;
      }
      case UI_THUNK_ACTION_NAME.GET_STAGES_FUL_FILLED: {
        await waitForPlaycanvasReady();

        initFirstEnvironment()(store);
        break;
      }
      case "ui/getCategoryInfoThunkProducts:fetch/fulfilled": {
        // After folder details are loaded, if user has entered a search value,
        // recompute search results scoped to this folder
        const stateNow = store.getState();
        const value = stateNow.ui.searchData.searchValue;
        if (value && value.length > 0) {
          changeSearchValue(value)(store);
        }
        break;
      }
      case UI_ACTION_NAME.FINISH_OBJECT_PROCESS: {
        finishedProcessObject(action.payload)(store);
        break;
      }
      default: {
        break;
      }
    }

    return result;
  };
